import Vue from 'vue';
//import moment from 'moment';
import { DateTime } from "luxon";

import Inputmask from 'inputmask'

Vue.directive('mask', {
    bind: function(el, binding) {
        Inputmask(binding.value).mask(el);
    }
});


Vue.filter('date', function(value, dateFormat = "dd-LL-yyyy HH-mm") { // HH-mm
    //dateFormat = 'MMMM Do YYYY, h:mm:ss a'
    if (!value) return "Укажите дату";

    if (typeof value === 'string') {
        return DateTime.fromISO(value, { zone: 'utc' }).toFormat(dateFormat)
    }

    if (value instanceof Date) {
        return DateTime.fromJSDate(value).toFormat(dateFormat)
    }


    if (value instanceof DateTime) {
        return value.toFormat(dateFormat)
    }


});

Vue.filter('numbering', function(value) {
    if (typeof value === 'number') value = value.toRound();
    //return value;
    if (!value) return "0";
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(".");
    //return moment(value).locale("ru").format(dateFormat);
});
/*Date.prototype.format = (dateFormat = 'MMMM Do YYYY, h:mm:ss a') => {
    return moment(this).locale("ru").format(dateFormat);
}*/
Vue.filter('short', function(value, ln = 128) {
    let newVal;
    if (!value) return "";
    if (value.length > ln) {
        newVal = value.substring(0, ln);
        if (newVal[ln] != ' ') newVal = newVal + "...";
    } else {
        newVal = value;
    }

    return newVal;
});
/*Vue.filter('calendar', function(value) {
    return moment(value).locale("ru").fromNow();
});*/

Vue.directive('show-delay', {

    /*
        show-delay directive
        use: v-show-delay="true|false"
    */
    bind(el, binding, vnode) {
        let showDisplay = 'block';
        if(el.attributes['show-display']){
            showDisplay = el.attributes['show-display'].value
        }
        if (vnode.timer) clearTimeout(vnode.timer);
        if (binding.value) {
            el.style.display = showDisplay;
            vnode.timer = setTimeout(() => {
                el.classList.add('shown');
                vnode.timer = false;
            }, 100);


        } else {
            el.classList.remove('shown');

            vnode.timer = setTimeout(() => {
                el.style.display = 'none';
                vnode.timer = false;
            }, 100);

        }
    },
    update: function(el, binding, vnode) {
        let showDisplay = 'block';
        if(el.attributes['show-display']){
            showDisplay = el.attributes['show-display'].value
        }
        if (binding.value) {
            el.style.display = showDisplay;
            if (vnode.timer) clearTimeout(vnode.timer);
            vnode.timer = setTimeout(() => {
                el.classList.add('shown');
                vnode.timer = false;
            }, 100);
        } else {
            el.classList.remove('shown');
            if (vnode.timer) clearTimeout(vnode.timer);
            vnode.timer = setTimeout(() => {
                el.style.display = 'none';
                vnode.timer = false;
            }, 400);
        }
    }
});
Vue.directive('scroll-top', {
    bind(el, binding, vnode) {
        console.log(el)
        el.addEventListener('click', () => {
            window.scrollTo(0, 0);
        });
    }
});

Vue.directive('show-hide-delay', {
    bind(el, binding, vnode) {
        el.classList[binding.value ? 'add' : 'remove']('shown');
        el.style.display = binding.value ? 'block' : 'none';
    },
    update: function(el, binding) {
        if (binding.value) {
            el.style.display = 'block';
            el.style.opacity = 0;
            setTimeout(() => {
                el.style.opacity = 1;
            }, 100);
        } else {
            el.style.opacity = 0;
            setTimeout(() => {
                el.style.display = 'none';
            }, 300);
        }
    }
});
Vue.directive('number-animate', {
    bind(el, binding, vnode) {
        if (!el.innerText) el.innerText = "0";
        let step = binding.value / 100;
        if (step < 1) step = 1;
        let interval = setInterval(() => {
            let num = parseInt(el.innerText);
            el.innerText = num + step;
            if (num > binding.value) {
                el.innerText = binding.value;
                clearInterval(interval);
            }
        }, 10);
    },
    update: function(el, binding) {
        //binding.value
    }
});


Vue.directive('scroll', {
    inserted: function(el, binding) {
        let f = function(evt) {
            if (binding.value(evt, el)) {
                el.removeEventListener('wheel', f)
            }
        }
        el.addEventListener('wheel', f)
    }
})